import { createSlice } from '@reduxjs/toolkit'

// example of state: [{ code: 'TOKEN_FAILED', type: "ERROR"}, ...]

const loaderSlice = createSlice({
    name: 'loader',
    initialState: {
        loading: false,
    },
    reducers: {
        startLoading(state) {
            state.loading = true
        },
        stopLoading(state) {
            state.loading = false
        },
    },
})

const { actions, reducer } = loaderSlice

export const { startLoading, stopLoading } = actions

export default reducer
